// client/src/components/profile/connectedApps/DisconnectAppDialog.js
import { useEffect, useRef } from 'react';

export default function DisconnectAppDialog({ app, onConfirm, onCancel, busy }) {
  const cancelRef = useRef(null);
  useEffect(() => { cancelRef.current?.focus(); }, []);
  const name = app.display_text;
  const onKeyDown = (e) => {
    if (e.key === 'Escape' && !busy) onCancel();
    // Focus trap between the two buttons.
    if (e.key === 'Tab') {
      const nodes = e.currentTarget.querySelectorAll('button:not([disabled])');
      if (!nodes.length) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };
  return (
    <div className="ca-dialog-backdrop">
      <div className="ca-dialog" role="alertdialog" aria-modal="true" aria-labelledby="ca-dialog-title"
        aria-describedby="ca-dialog-body" aria-busy={busy} onKeyDown={onKeyDown}>
        <h2 id="ca-dialog-title" className="ca-dialog__title">Disconnect {name}?</h2>
        <p id="ca-dialog-body" className="ca-dialog__body">
          {name} will no longer be able to sign you in with Google or use your Google account. Your account inside {name} isn't deleted. Close it in {name} if you no longer need it.
        </p>
        {app.app_id && <p className="ca-dialog__id">App ID: {app.app_id}</p>}
        <div className="ca-dialog__actions">
          <button type="button" className="btn btn-secondary" ref={cancelRef} onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={busy}>
            {busy ? 'Disconnecting…' : 'Disconnect'}
          </button>
        </div>
      </div>
    </div>
  );
}
